import * as i0 from '@angular/core';
import { input, computed, ChangeDetectionStrategy, Component } from '@angular/core';

var EffyHashtagSize;
(function (EffyHashtagSize) {
    EffyHashtagSize["SMALL"] = "small";
    EffyHashtagSize["MEDIUM"] = "medium";
})(EffyHashtagSize || (EffyHashtagSize = {}));
var EffyHashtagStyle;
(function (EffyHashtagStyle) {
    EffyHashtagStyle["PRIMARY"] = "primary";
    EffyHashtagStyle["SECONDARY"] = "secondary";
})(EffyHashtagStyle || (EffyHashtagStyle = {}));

class EffyHashtagComponent {
    constructor() {
        this.size = input(EffyHashtagSize.MEDIUM, ...(ngDevMode ? [{ debugName: "size" }] : []));
        this.color = input(EffyHashtagStyle.PRIMARY, ...(ngDevMode ? [{ debugName: "color" }] : []));
        this.hostClasses = computed(() => `effy-hashtag effy-hashtag-${this.size()} effy-hashtag-${this.color()}`, ...(ngDevMode ? [{ debugName: "hostClasses" }] : []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "20.1.6", ngImport: i0, type: EffyHashtagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "20.1.6", type: EffyHashtagComponent, isStandalone: true, selector: "[effy-hashtag]", inputs: { size: { classPropertyName: "size", publicName: "size", isSignal: true, isRequired: false, transformFunction: null }, color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class": "hostClasses()" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "20.1.6", ngImport: i0, type: EffyHashtagComponent, decorators: [{
            type: Component,
            args: [{ selector: '[effy-hashtag]', imports: [], changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class]': 'hostClasses()',
                    }, template: "<ng-content></ng-content>\n" }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EffyHashtagComponent, EffyHashtagSize, EffyHashtagStyle };
